import React, {useEffect, useState} from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import {Button} from "../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {Title} from "../../../../../stories/Title/Title";
import WorkProgressTable from "../projectdetails/WorkProgressTable";
import ParticularProjectDetails from "../projectdetails/ParticularProjectDetails";
import {CustomModal} from "../../../../../utils/UtilFunctions";
import {
  AddModalStyles,
  EditModalStyles,
} from "../../../../../styles/CustomModalStyles";
import AddTableStructure from "./add/AddTableStructure";
import TableStructureList from "./Table";
import Close from "../../../../../images/Close.svg";
import Copy from "../../../../../images/Copy.svg";
import {CustomDrawer} from "../../../../../styles/CustomDrawerStyles";
import CopyTableFormat from "./add/CopyTableFormat";
import Assign from "../../../../../images/Assign.svg";
import InitializeData from "./InitializeData";
import {
  CheckProjectAnyInitHeader,
  CheckProjectDailyReportStarted,
} from "../../masters/projects/queries/queries";
import {
  CheckProjectAnyInitHeaderResult,
  CheckProjectAnyInitHeaderVar,
  CheckProjectDailyReportStartedResult,
  CheckProjectDailyReportStartedVar,
} from "../../masters/projects/queries/types";
import {useLazyQuery} from "@apollo/client";
import useUrlParams from "../../../../../customHooks/useUrlParams";
interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}
interface StateType {
  operation: Operation;
  flag: boolean;
}
const ViewTableStructure = ({setModal, pageType}: Props) => {
  const navigate = useNavigate();
  const [addModal, setAddModal] = useState(false);
  const [copyProject, setCopyProject] = useState(false);

  const {customer_id, projectID} = useUrlParams();

  const [instializeData, setInitializeData] = useState<StateType>({
    flag: false,
    operation: Operation.CREATE,
  });

  const [GetTableStructure, {data}] = useLazyQuery<
    CheckProjectAnyInitHeaderResult,
    CheckProjectAnyInitHeaderVar
  >(CheckProjectAnyInitHeader);

  const [GetProjectResportStarted, {data: reportStarted}] = useLazyQuery<
    CheckProjectDailyReportStartedResult,
    CheckProjectDailyReportStartedVar
  >(CheckProjectDailyReportStarted);

  useEffect(() => {
    if (customer_id && projectID)
      GetTableStructure({
        variables: {
          customerID: customer_id,
          projectID: projectID,
        },
      });
  }, [customer_id, projectID, GetTableStructure]);

  useEffect(() => {
    if (customer_id && projectID)
      GetProjectResportStarted({
        variables: {
          customerID: customer_id,
          projectID: projectID,
        },
      });
  }, [customer_id, projectID, GetProjectResportStarted]);

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.DASHBOARD} />
      )}

      <Title>Work Progress</Title>
      {pageType === PageFor.MODAL && (
        <img
          src={Close}
          alt=""
          onClick={() => setModal(false)}
          className="modal-close-icon"
        />
      )}
      <div className="wp-project-details">
        <ParticularProjectDetails />
        {data && data.CheckProjectAnyInitHeader
          ? pageType === PageFor.GENERAL && (
              <div className="wp-project-details__initialize">
                {reportStarted &&
                reportStarted.CheckProjectDailyReportStarted ? null : (
                  <b className="font-red">
                    Initialize data is Missing Please Fill the Data
                  </b>
                )}
                <Button
                  mode="transfer"
                  onClick={() =>
                    setInitializeData({
                      flag: true,
                      operation:
                        reportStarted &&
                        reportStarted.CheckProjectDailyReportStarted
                          ? Operation.UPDATE
                          : Operation.CREATE,
                    })
                  }
                >
                  <img src={Assign} alt="" />
                  {reportStarted && reportStarted.CheckProjectDailyReportStarted
                    ? "Update"
                    : "Initialize"}{" "}
                  Data
                </Button>
              </div>
            )
          : null}

        <div className={`wp-project-details__block${data && data.CheckProjectAnyInitHeader
          ? "--wh":""}`}>
          <TableStructureList />
        </div>
        <Button mode="update" onClick={() => setAddModal(!addModal)}>
          {" "}
          Table Structure
        </Button>
        <Button mode="back" onClick={() => navigate(-1)} />

        {/* {pageType === PageFor.GENERAL ? (
          <>
            {" "}
            <Button mode="addnew" onClick={() => setAddModal(!addModal)}>
              {" "}
              Table Structure
            </Button>
            <Button mode="update" onClick={() => setAddModal(!addModal)}>
              {" "}
              Table Structure
            </Button>
            <Button
              mode="update"
              onClick={() =>
                setInitializeData({
                  flag: true,
                  operation: Operation.UPDATE,
                })
              }
            >
              {" "}
              InitialiZed Data
            </Button>
            <Button mode="back" onClick={() => navigate(-1)} />
          </>
        ) : (
          <>
            <Button mode="save" />
            <Button mode="cancel" onClick={() => setModal(false)} />
          </>
        )} */}
      </div>
      <CustomModal
        style={AddModalStyles}
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={<AddTableStructure setModal={setAddModal} />}
      />
      <CustomDrawer
        anchor="right"
        open={copyProject}
        onClose={() => setCopyProject(!copyProject)}
      >
        <CopyTableFormat setModal={setCopyProject} />
      </CustomDrawer>
      {instializeData.flag && (
        <CustomModal
          style={EditModalStyles}
          isOpen={instializeData.flag}
          onRequestClose={() =>
            setInitializeData({
              flag: false,
              operation: Operation.NONE,
            })
          }
          contentComponent={
            <InitializeData
              setModal={() =>
                setInitializeData({
                  flag: false,
                  operation: Operation.NONE,
                })
              }
              operation={instializeData.operation}
            />
          }
        />
      )}
    </>
  );
};

export default ViewTableStructure;
